export default {
  filters: {
    snakeToHuman: (text) =>
      text
        .replaceAll("_", " ")
        .toLowerCase()
        .replace(/\b[a-zA-Z]/g, (word) => word.toUpperCase()),
  },
};
